import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  handleError,
  handleReceive,
  selectConfigState,
} from '../redux/configuration'
import vitAPI from '../api'
import LoadingScreen from '../components/LoadingScreen/LoadingScreen'
import useOnMount from '../hooks/useOnMount'

const ConfigProvider = ({ children }) => {
  const state = useSelector(selectConfigState)
  const dispatch = useDispatch()

  const fetchConfig = () => {
    vitAPI
      .getConfiguration('en')
      .then(({ data }) => {
        dispatch(handleReceive(data))
      })
      .catch((err) => {
        dispatch(handleError(err?.message || 'Error fetching configuration'))
      })
  }
  useOnMount(fetchConfig)
  return state?.loading ? (
    <LoadingScreen />
  ) : state?.error ? (
    <p>{state.error}</p>
  ) : (
    children
  )
}

export default ConfigProvider
